<script>
</script>

<div class="branding">
  <span>Retale.me - https://retale.me</span>
</div>

<style lang="scss">
  .branding {
    display: none;
    position: fixed;
    bottom: 50px;
    flex-direction: column;
    font-size: $fontSize-small;
    opacity: 0.5;
  }
</style>
